module.exports = __webpack_public_path__ + "static/media/AB_ZW10_1.19ef4d66.jpg";